﻿export function topicPrefiltering(resourceState) {
    const paramsString = new URLSearchParams(window.location.search);
    const topicsParams = (paramsString.getAll('topic'));
    const topics = document.querySelectorAll('.resource-topic-filter__checkbox');
    if (topicsParams.length != 0 && topicsParams[0] !== "") {
        const topicsArray = topicsParams[0].split(',');
        resourceState.topics = topicsArray;
        for (const topic of topicsArray) {
            const input = document.querySelector(`input[data-value="${topic}"]`);
            input.checked = true;
        }
    }
}

export function countryPrefiltering(resourceState) {
    const paramsString = new URLSearchParams(window.location.search);
    const countryParams = (paramsString.getAll('country'));
    const countries = document.querySelectorAll('.resource-country-filter__checkbox');
    if (countryParams.length != 0 && countryParams[0] !== "") {
        const countriesArray = countryParams[0].split(',');
        resourceState.country = countriesArray;
        for (const country of countriesArray) {
            const input = document.querySelector(`input[data-value="${country}"]`);
            input.checked = true;
        }
    }
}

export function formatPrefiltering(resourceState) {
    const paramsString = new URLSearchParams(window.location.search);
    const formatParams = (paramsString.getAll('format'));
    const formats = document.querySelectorAll('.resource-format-filter__checkbox');
    if (formatParams.length != 0 && formatParams[0] !== "") {
        const formatsArray = formatParams[0].split(',');
        resourceState.format = formatsArray;
        for (const format of formatsArray) {
            const input = document.querySelector(`input[data-value="${format}"]`);
            input.checked = true;
        }
    }
}

export function typePrefiltering(resourceState) {

}